import { render, staticRenderFns } from "./poa_subfunciones.vue?vue&type=template&id=5b761d8b&"
import script from "./poa_subfunciones.vue?vue&type=script&lang=ts&"
export * from "./poa_subfunciones.vue?vue&type=script&lang=ts&"
import style0 from "./poa_subfunciones.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports